var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.78198 691.66664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c7c7c;\n      }\n\n      .cls-2 {\n        fill: #c6c6c6;\n        opacity: 0.4;\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.32667,115V231.66666A58.18455,58.18455,0,0,1,573.99334,290h-275.331a60.11424,60.11424,0,0,1-36.334-12.66667L189.328,219c-29-23.33333-29-68,0-91.33332l73.00033-58.33334a60.11214,60.11214,0,0,1,36.334-12.66667h275.331A58.18455,58.18455,0,0,1,632.32667,115Z",
    transform: "translate(-167.578 -56.66666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.36,552.33334l-72.66661,58.33333a60.332,60.332,0,0,1-36.66671,12.66664h-275.334A58.18456,58.18456,0,0,1,168.35932,565V448.33332A58.18454,58.18454,0,0,1,226.69265,390h275.334a60.332,60.332,0,0,1,36.66671,12.66667L611.36,461A58.39644,58.39644,0,0,1,611.36,552.33334Z",
    transform: "translate(-167.578 -56.66666)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425,290H375V390h50Z",
    transform: "translate(-167.578 -56.66666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525,723.33331a25.18206,25.18206,0,0,1-25,25H300a25,25,0,1,1,0-50h75v-75h50v75h75A25.18206,25.18206,0,0,1,525,723.33331Z",
    transform: "translate(-167.578 -56.66666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.39522c48.svg";
export { ForwardRef as ReactComponent };